import React from "react";
import { Select } from "antd";

export const MySelect = ({
  width = 300,
  handleChange,
  options = [],
  placeholder = "Пошук...",
  prefix = "",
  mode = "",
  disabled = false,
}) => (
  <Select
    disabled={disabled}
    mode={mode}
    prefix={prefix}
    placeholder={placeholder}
    style={{ width: width }}
    onChange={handleChange}
    options={options}
  />
);
